'use client';

import ImageProxy from '@next-image-proxy';

import { ExternalLink } from '@uikit';

import { DiscordCircleSmall } from '@uikit/icons/DiscordCircleSmall';
import { TelegramCircle } from '@uikit/icons/TelegramCircle';

import { LAUNCHPAD_URL } from '@shared/constants';

import { processes } from './constants';

const Page = () => (
  <main className="main-container max-w-[1332px] px-4 py-6 sm:py-16">
    <h1 className="mb-8 sm:mb-16 text-2xl sm:text-5xl text-center font-medium">How it Works</h1>

    <section className="flex justify-between flex-col gap-4 sm:gap-6 mb-6 sm:mb-16">
      {processes.map(
        ({ id, step, header, description, content, subDescription, subcomponent, pools }) => {
          const showPools = Boolean(pools?.length);

          return (
            <div key={id} className="p-4 sm:p-6 border border-primary-200 rounded-lg">
              <div className="flex sm:items-center max-sm:flex-col mb-4 sm:mb-6 gap-4">
                <div className="flex items-center justify-center min-w-fit w-28 h-10 py-1 px-4 text-2xl font-semibold bg-[linear-gradient(246deg,_#FF8066_0%,_#E566FF_50%,_#66B2FF_100%)] rounded-full text-neutral-50">
                  {step}
                </div>

                <h3 className="text-xl sm:text-2xl font-semibold">{header}</h3>
              </div>

              {content && <div className="text-lg mb-4">{content}</div>}

              {description && <p className="text-lg mb-4">{description}</p>}

              {subcomponent && (
                <div className="flex items-start gap-2 p-4 sm:mt-6 border border-primary-600 bg-primary-50 rounded-lg">
                  <span className="min-w-6 h-6">
                    <subcomponent.Icon />
                  </span>

                  <div className="flex flex-col gap-1">
                    <h3 className="text-[18px] font-normal">{subcomponent.header}</h3>
                    <p className="text-base">{subcomponent.description}</p>
                  </div>
                </div>
              )}

              {subDescription && <p className="mb-4 text-xl font-normal">{subDescription}</p>}

              {showPools && (
                <div className="flex gap-4 max-md:flex-col">
                  {pools?.map(({ poolId, image, poolHeader, poolDescription }) => (
                    <div
                      key={poolId}
                      className="flex flex-col w-full p-4 rounded-lg border border-primary-600 bg-primary-50"
                    >
                      <ImageProxy
                        src={image}
                        alt={poolHeader}
                        className="mb-2 w-12 h-12 aspect-square flex-shrink-0"
                        width={100}
                        height={100}
                        quality={100}
                      />

                      <h3 className="mb-1 text-[18px] font-medium">{poolHeader}</h3>
                      <p className="text-base">{poolDescription}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        },
      )}
    </section>

    <p className="text-[18px] font-semibold mb-4">
      If you have any further questions Please don't hesitate to reach out to our Community
      Management Team. You can contact them via Telegram or Discord, and they will be happy to
      assist you.
    </p>

    <div className="flex gap-6">
      <ExternalLink
        href={LAUNCHPAD_URL.magicLaunchpadTG2}
        className="flex justify-center items-center w-16 h-16 rounded-md bg-neutral-50 border border-neutral-100"
      >
        <TelegramCircle className="icon-lg w-12 h-12" />
      </ExternalLink>

      <ExternalLink
        href={LAUNCHPAD_URL.discord}
        className="flex justify-center items-center w-16 h-16 rounded-md bg-neutral-50 border border-neutral-100"
      >
        <DiscordCircleSmall className="icon-lg w-12 h-12" />
      </ExternalLink>
    </div>
  </main>
);

export default Page;
